import { Card, CardColors, Separator, Text } from '@/ui'
import { InstitutionLogo } from '@/features/user/settings/sections/connected-financial-institutions-card/institution-card/logo'
import { PlaidItem } from '@/reducers/finances/plaidItemReducer'
import { TypographyStyles } from '@/styles'

export const UnsupportedInstitutionCard = ({
  institution,
}: {
  institution: PlaidItem
}) => {
  return (
    <Card
      color={CardColors.LEVEL_1}
      className="flex flex-col h-full p-4 space-y-4"
    >
      <div className="flex items-center gap-4">
        <div className="w-10">
          <InstitutionLogo
            className="institutionLogo"
            institution={institution}
          />
        </div>
        <Text variant={TypographyStyles.H3} className="text-left m-0">
          {institution.institutionName}
        </Text>
      </div>

      <Separator />

      <ul className="list-disc pl-5 space-y-1">
        {institution.accounts.map((account) => (
          <li key={account.id}>
            <Text>{account.name}</Text>
          </li>
        ))}
      </ul>
    </Card>
  )
}
